let base = process.env.base_url;

export const businessName = {
    student: '选择学生',
    classlist: '选择班级',
    teacher: '选择老师',
    department: '选择部门'
}

const components = {
    input: {
        // 组件的自定义配置
        category: 'input',
        __config__: {
            label: '单行文本',
            labelWidth: null,
            showLabel: true,
            changeTag: true,
            tag: 'el-input',
            tagIcon: 'input',
            defaultValue: undefined,
            required: true,
            layout: 'colFormItem',
            span: 24,
            document: 'https://element.eleme.cn/#/zh-CN/component/input',
            // 正则校验规则
            regList: []
        },
        // 组件的插槽属性
        __slot__: {
            prepend: '',
            append: ''
        },
        // 其余的为可直接写在组件标签上的属性
        placeholder: '请输入',
        style: {
            width: '100%'
        },
        clearable: true,
        'prefix-icon': '',
        'suffix-icon': '',
        maxlength: null,
        'show-word-limit': false,
        readonly: false,
        disabled: false
    },
    textarea: {
        category: 'textarea',
        __config__: {
            label: '多行文本',
            labelWidth: null,
            showLabel: true,
            tag: 'el-input',
            tagIcon: 'textarea',
            defaultValue: undefined,
            required: true,
            layout: 'colFormItem',
            span: 24,
            regList: [],
            changeTag: true,
            document: 'https://element.eleme.cn/#/zh-CN/component/input'
        },
        type: 'textarea',
        placeholder: '请输入',
        autosize: {
            minRows: 4,
            // maxRows: 4
        },
        style: {
            width: '100%'
        },
        maxlength: null,
        'show-word-limit': false,
        readonly: false,
        disabled: false
    },
    password: {
        category: 'password',
        __config__: {
            label: '密码',
            showLabel: true,
            labelWidth: null,
            changeTag: true,
            tag: 'el-input',
            tagIcon: 'password',
            defaultValue: undefined,
            layout: 'colFormItem',
            span: 24,
            required: true,
            regList: [],
            document: 'https://element.eleme.cn/#/zh-CN/component/input'
        },
        __slot__: {
            prepend: '',
            append: ''
        },
        placeholder: '请输入',
        'show-password': true,
        style: {
            width: '100%'
        },
        clearable: true,
        'prefix-icon': '',
        'suffix-icon': '',
        maxlength: null,
        'show-word-limit': false,
        readonly: false,
        disabled: false
    },
    number: {
        category: 'number',
        __config__: {
            label: '计数器',
            showLabel: true,
            changeTag: true,
            labelWidth: null,
            tag: 'el-input-number',
            tagIcon: 'number',
            defaultValue: undefined,
            span: 24,
            layout: 'colFormItem',
            required: true,
            regList: [],
            document: 'https://element.eleme.cn/#/zh-CN/component/input-number'
        },
        placeholder: '',
        min: undefined,
        max: undefined,
        step: 1,
        'step-strictly': false,
        precision: undefined,
        'controls-position': 'right',
        disabled: false,
        unit: ''
    },

    picker: {
        category: 'picker',
        __config__: {
            label: '下拉选择',
            showLabel: true,
            labelWidth: null,
            tag: 'el-select',
            tagIcon: 'select',
            layout: 'colFormItem',
            span: 24,
            required: true,
            dataType: 'static',
            regList: [],
            changeTag: true,
            document: 'https://element.eleme.cn/#/zh-CN/component/select'
        },
        __slot__: {
            options: [{
                label: '选项一',
                value: 1
            }, {
                label: '选项二',
                value: 2
            }]
        },
       
        placeholder: '请选择',
        style: {
            width: '100%'
        },
        clearable: true,
        disabled: false,
        filterable: false,
        multiple: false
    },
    cascader: {
        category: 'cascader',
        __config__: {
            label: '级联选择',
            showLabel: true,
            labelWidth: null,
            tag: 'el-cascader',
            tagIcon: 'cascader',
            layout: 'colFormItem',
            defaultValue: [],
            dataType: 'static',
            span: 24,
            required: true,
            regList: [],
            changeTag: true,
            document: 'https://element.eleme.cn/#/zh-CN/component/cascader'
        },
        options: [{
            id: 1,
            value: 1,
            label: '选项1',
            children: [{
                id: 2,
                value: 2,
                label: '选项1-1'
            }]
        }],
        placeholder: '请选择',
        style: {
            width: '100%'
        },
        props: {
            props: {
                multiple: false,
                label: 'label',
                value: 'value',
                children: 'children'
            }
        },
        'show-all-levels': true,
        disabled: false,
        clearable: true,
        filterable: false,
        separator: '，'
    },
    radio: {
        category: 'radio',
        __config__: {
            label: '单选框组',
            labelWidth: null,
            showLabel: true,
            tag: 'el-radio-group',
            tagIcon: 'radio',
            changeTag: true,
            defaultValue: undefined,
            layout: 'colFormItem',
            span: 24,
            optionType: 'default',
            regList: [],
            required: true,
            border: false,
            document: 'https://element.eleme.cn/#/zh-CN/component/radio'
        },
        __slot__: {
            options: [{
                label: '选项一',
                value: 1
            }, {
                label: '选项二',
                value: 2
            }]
        },
        style: {},
        size: 'medium',
        disabled: false
    },
    checkbox: {
        category: 'checkbox',
        __config__: {
            label: '多选框组',
            tag: 'el-checkbox-group',
            tagIcon: 'checkbox',
            defaultValue: [],
            span: 24,
            showLabel: true,
            labelWidth: null,
            layout: 'colFormItem',
            optionType: 'default',
            required: true,
            regList: [],
            changeTag: true,
            border: false,
            document: 'https://element.eleme.cn/#/zh-CN/component/checkbox'
        },
        __slot__: {
            options: [{
                label: '选项一',
                value: 1
            }, {
                label: '选项二',
                value: 2
            }]
        },
        style: {},
        size: 'medium',
        min: null,
        max: null,
        disabled: false
    },
    switch: {
        category: 'switch',
        __config__: {
            label: '开关',
            tag: 'el-switch',
            tagIcon: 'switch',
            defaultValue: false,
            span: 24,
            showLabel: true,
            labelWidth: null,
            layout: 'colFormItem',
            required: true,
            regList: [],
            changeTag: true,
            document: 'https://element.eleme.cn/#/zh-CN/component/switch'
        },
        style: {},
        disabled: false,
        'active-text': '',
        'inactive-text': '',
        'active-color': null,
        'inactive-color': null,
        'active-value': true,
        'inactive-value': false
    },
    slider: {
        category: 'slider',
        __config__: {
            label: '滑块',
            tag: 'el-slider',
            tagIcon: 'slider',
            defaultValue: null,
            span: 24,
            showLabel: true,
            layout: 'colFormItem',
            labelWidth: null,
            required: true,
            regList: [],
            changeTag: true,
            document: 'https://element.eleme.cn/#/zh-CN/component/slider'
        },
        disabled: false,
        min: 0,
        max: 100,
        step: 1,
        'show-stops': false,
        range: false
    },
    time: {
        category: 'time',
        __config__: {
            label: '时间选择',
            tag: 'el-time-picker',
            tagIcon: 'time',
            defaultValue: null,
            span: 24,
            showLabel: true,
            layout: 'colFormItem',
            labelWidth: null,
            required: true,
            regList: [],
            changeTag: true,
            document: 'https://element.eleme.cn/#/zh-CN/component/time-picker'
        },
        placeholder: '请选择',
        style: {
            width: '100%'
        },
        disabled: false,
        clearable: true,
        'picker-options': {
            selectableRange: '00:00:00-23:59:59'
        },
        format: 'HH:mm:ss',
        'value-format': 'HH:mm:ss'
    },
    timerange: {
        category: 'timerange',
        __config__: {
            label: '时间范围',
            tag: 'el-time-picker',
            tagIcon: 'time-range',
            span: 24,
            showLabel: true,
            labelWidth: null,
            layout: 'colFormItem',
            defaultValue: null,
            required: true,
            regList: [],
            changeTag: true,
            document: 'https://element.eleme.cn/#/zh-CN/component/time-picker'
        },
        style: {
            width: '100%'
        },
        disabled: false,
        clearable: true,
        'is-range': true,
        'range-separator': '至',
        'start-placeholder': '开始时间',
        'end-placeholder': '结束时间',
        format: 'HH:mm:ss',
        'value-format': 'HH:mm:ss'
    },
    date: {
        category: 'date',
        __config__: {
            label: '日期选择',
            tag: 'el-date-picker',
            tagIcon: 'date',
            defaultValue: null,
            showLabel: true,
            labelWidth: null,
            span: 24,
            layout: 'colFormItem',
            required: true,
            regList: [],
            changeTag: true,
            document: 'https://element.eleme.cn/#/zh-CN/component/date-picker'
        },
        placeholder: '请选择',
        type: 'date',
        style: {
            width: '100%'
        },
        disabled: false,
        clearable: true,
        format: 'yyyy-MM-dd',
        'value-format': 'yyyy-MM-dd',
        readonly: false
    },
    daterange: {
        category: 'daterange',
        __config__: {
            label: '日期范围',
            tag: 'el-date-picker',
            tagIcon: 'date-range',
            defaultValue: [],
            span: 24,
            showLabel: true,
            labelWidth: null,
            required: true,
            layout: 'colFormItem',
            regList: [],
            changeTag: true,
            document: 'https://element.eleme.cn/#/zh-CN/component/date-picker'
        },
        style: {
            width: '100%'
        },
        type: 'daterange',
        'range-separator': '至',
        'start-placeholder': '开始日期',
        'end-placeholder': '结束日期',
        disabled: false,
        clearable: true,
        format: 'yyyy-MM-dd',
        'value-format': 'yyyy-MM-dd',
        readonly: false
    },
    rate: {
        category: 'rate',
        __config__: {
            label: '评分',
            tag: 'el-rate',
            tagIcon: 'rate',
            defaultValue: 0,
            span: 24,
            showLabel: true,
            labelWidth: null,
            layout: 'colFormItem',
            required: true,
            regList: [],
            changeTag: true,
            document: 'https://element.eleme.cn/#/zh-CN/component/rate'
        },
        style: {},
        max: 5,
        'allow-half': false,
        'show-text': false,
        'show-score': false,
        disabled: false
    },
    upload: {
        category: 'upload',
        __config__: {
            label: '上传',
            tag: 'el-upload',
            tagIcon: 'upload',
            layout: 'colFormItem',
            defaultValue: null,
            showLabel: true,
            labelWidth: null,
            required: true,
            span: 24,
            showTip: false,
            buttonText: '点击上传',
            regList: [],
            changeTag: true,
            fileSize: null,
            sizeUnit: 'MB',
            document: 'https://element.eleme.cn/#/zh-CN/component/upload',
        },
        __slot__: {
            'list-type': true
        },
        action: `${base}/oss/file/upload`,
        headers: {
            client: 'pc-school',
        },
        'with-credentials': true,
        'auto-upload': true,
        disabled: false,
        accept: 'image/*',
        name: 'file',
        'list-type': 'picture-card',
        multiple: true,  //是否支持多选文件
    },
    button: {
        category: 'button',
        __config__: {
            label: '按钮',
            showLabel: true,
            changeTag: true,
            labelWidth: null,
            tag: 'el-button',
            tagIcon: 'button',
            span: 24,
            layout: 'colFormItem',
            document: 'https://element.eleme.cn/#/zh-CN/component/button'
        },
        __slot__: {
            default: '主要按钮'
        },
        type: 'primary',
        icon: 'el-icon-search',
        round: false,
        size: 'medium',
        plain: false,
        circle: false,
        disabled: false
    },
    // 自定义的控件
    signature: {
        category: 'signature',
        __config__: {
            label: '手写签名',
            showLabel: true,
            changeTag: true,
            defaultValue: null,
            labelWidth: null,
            tag: '',
            tagIcon: '',
            span: 24,
            layout: 'colFormItem',
            document: '',
            required: false,
            regList: []
        },
        icon: '',
    },
    selectStudent: {
        category: 'selectBusiness', //选择学生/班级/老师/部门
        business_type: 'student', //student,classlist,teacher,department
        __config__: {
            label: '选择学生',
            showLabel: true,
            changeTag: true,
            labelWidth: null,
            defaultValue: [],
            tag: 'el-button',
            tagIcon: 'button',
            span: 24,
            layout: 'colFormItem',
            required: true,
        },
        __slot__: {
            default: '选择学生'
        },

        on: {
            click: 'openSelect'
        },
        type: 'primary',
        icon: 'el-icon-plus',
        round: false,
        size: 'medium',
        plain: false,
        circle: false,
        disabled: false,
        multiple: false, //是否多选
        max: 0, //最大选择数量，-1表示不限制
    },
    selectTeacher: {
        category: 'selectBusiness', //选择学生/班级/老师/部门
        business_type: 'teacher', //student,classlist,teacher,department
        __config__: {
            label: '选择老师',
            showLabel: true,
            changeTag: true,
            labelWidth: null,
            defaultValue: [],
            tag: 'el-button',
            tagIcon: 'button',
            span: 24,
            layout: 'colFormItem',
            required: true,
        },
        __slot__: {
            default: '选择老师'
        },
        on: {
            click: 'openSelect'
        },
        type: 'primary',
        icon: 'el-icon-plus',
        round: false,
        size: 'medium',
        plain: false,
        circle: false,
        disabled: false,
        multiple: false, //是否多选
        max: 0, //最大选择数量，0表示不限制
    },
    selectClass: {
        category: 'selectBusiness', //选择学生/班级/老师/部门
        business_type: 'classlist', //student,classlist,teacher,department
        __config__: {
            label: '选择班级',
            showLabel: true,
            changeTag: true,
            labelWidth: null,
            defaultValue: [],
            tag: 'el-button',
            tagIcon: 'button',
            span: 24,
            layout: 'colFormItem',
            required: true,
        },
        __slot__: {
            default: '选择班级'
        },
        on: {
            click: 'openSelect'
        },
        type: 'primary',
        icon: 'el-icon-plus',
        round: false,
        size: 'medium',
        plain: false,
        circle: false,
        disabled: false,
        multiple: false, //是否多选
        max: 0, //最大选择数量，0表示不限制
    },
    selectDepartment: {
        category: 'selectBusiness', //选择学生/班级/老师/部门
        business_type: 'department', //student,classlist,teacher,department
        __config__: {
            label: '选择部门',
            showLabel: true,
            changeTag: true,
            labelWidth: null,
            defaultValue: [],
            tag: 'el-button',
            tagIcon: 'button',
            span: 24,
            layout: 'colFormItem',
            required: true,
        },
        __slot__: {
            default: '选择部门'
        },
        on: {
            click: 'openSelect'
        },
        type: 'primary',
        icon: 'el-icon-plus',
        round: false,
        size: 'medium',
        plain: false,
        circle: false,
        disabled: false,
        multiple: false, //是否多选
        max: 0, //最大选择数量，0表示不限制
    },
}

// 业务套件
// list 只配置可以覆盖的属性
const businessKits = {
    student_kq: {
        isKit: true,
        name: 'student_kq',
        formType: 2,
        __config__: {
            tagIcon: 'input',
            label: '学生请假套件',
            description: '审核通过的数据将关联至学生考勤',
            layout: 'colFormItem'
        },
        list: [
            {
                category: 'picker',
                __config__: {
                    label: '请假类型'
                },
                __slot__: {
                    options: [{
                        label: '病假',
                        value: 'SICK'
                    }, {
                        label: '事假',
                        value: 'PERSONAL'
                    }]
                },
                __vModel__: 'leave_type',
            }, {
                category: 'date',
                __config__: {
                    label: '开始日期'
                },
                __vModel__: "start_date"
            }, {
                category: 'date',
                __config__: {
                    label: '结束日期'
                },
                __vModel__: "end_date",
            }, {
                category: 'number',
                __config__: {
                    label: '请假天数'
                },
                __vModel__: "count",
            }, {
                category: 'textarea',
                __config__: {
                    label: '请假事由'
                },
                __vModel__: "reason"
            }
        ]
    }
}

// 表单属性【右面板】
export function getFromConf() {
    return {
        formRef: 'elForm',
        formModel: 'formData',
        size: 'medium',
        labelPosition: 'right',
        labelWidth: 100,
        formRules: 'rules',
        gutter: 15,
        disabled: false,
        span: 24,
        formBtns: true,
        businessKit: ''
    }
}
export function generatorCompoments(formType) {

    let selectComponents = [
        components.cascader,
        components.checkbox,
        components.date,
        components.daterange,
        components.picker,
        components.radio,
        components.rate,
        components.slider,
        components.switch,
        components.time,
        components.timerange,
        components.upload
    ]

    if (formType == 1) {
        selectComponents = selectComponents.concat([
            components.selectClass,
            components.selectDepartment,
            components.selectStudent,
            components.selectTeacher
        ])
    }
    if(formType==3){
        selectComponents = selectComponents.concat([
            components.selectClass,
          
            components.selectStudent
      
        ])
    }

    let list = [
        {
            title: "输入型组件",
            list: [
                components.input,
                components.number,
                components.password,
                components.textarea
            ],
        }, {
            title: "选择型组件",
            list: selectComponents
        }, {
            title: "其它控件",
            list: [
                components.signature,
                components.button
            ],
        }
    ]

    return list;
}
export function generatorBusinessKits(formType) {
    let confs = [
        {
            title: "考勤套件",
            list: [
                businessKits.student_kq
            ]
        }
    ]
    for(let i=0;i<confs.length;i++){
        let conf = confs[i]
        conf.list = conf.list.filter(v => v.formType == formType)
        if(!conf.list || conf.list.length<=0){
            confs.splice(i--,1)
        }
        conf.list.map(o => {
            o.list.map(v => {
                let temp = JSON.parse(JSON.stringify(components[v.category]))
                v.__config__ = v.__config__ ? Object.assign(temp.__config__, v.__config__) : temp.__config__
                v.__slot__ = v.__slot__ ? Object.assign(temp.__slot__, v.__slot__) : temp.__slot__
                v = Object.assign(temp, v)
                return v
            })
            return o
        })
    }
    return confs
}



// WEBPACK FOOTER //
// ./src/components/form/generator/config.js